import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        theme: localStorage.getItem("theme") === 'dark' ? "dark" : "light",
        token: localStorage.getItem("token"),
        user_info: localStorage.getItem("user_info"),
        user_accesses: []
    },
});